module.exports = __webpack_public_path__ + "static/media/5-1.9a18b1c1.mp3";